var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import '../../../components/modal';
import { t } from 'i18next';
import { deleteApiAbsoluteURL } from '../../../utils/fetcher';
import { updateEvent } from '../../../utils/updateEvent';
import { BaseComponent } from '../../../utils/BaseComponent';
import '../../../components/button';
import { Feedback } from './Feedback';
import { GiveReply } from './GiveReply';
import { DeleteReply } from './DeleteReply';
import { consume } from '@lit-labs/context';
import { reportContext } from '../context/ReportContext';
import { replyContext } from '../context/ReplyContext';
import "./Report";
import { trackEvent } from '../../../utils/trackPulse';
let PrivateListingButtonGroup = class PrivateListingButtonGroup extends BaseComponent {
    constructor() {
        super(...arguments);
        this.areYouSureYouWantToDeleteFeedback = false;
        this.areYouSureYouWantToDeleteReply = false;
        this.confirm = () => {
            this.deleteFeedback();
        };
        this.cancel = () => {
            this.areYouSureYouWantToDeleteFeedback = false;
        };
    }
    willUpdate(_changedProperties) {
        if (_changedProperties.has('me')
            ||
                _changedProperties.has('other')) {
            this.reply.setContext({ show: false });
            this.report.setContext({ show: false });
            this.areYouSureYouWantToDeleteFeedback = false;
            this.areYouSureYouWantToDeleteReply = false;
        }
    }
    render() {
        var _a;
        const participant = this.feedbackGiven ? this.me : this.other;
        if (!participant.feedback)
            return nothing;
        if (this.feedbackGiven) {
            return html `
        <trust-modal
          ?show='${this.areYouSureYouWantToDeleteFeedback}'
          confirmText='${t('Delete')}'
          @confirm='${this.confirm}'
          destructive
          @cancel='${this.cancel}'>
          <div class="w-full md:w-[600px]">
            <h3 class='mt-0'>${t('Delete')} ${t('Feedback').toLowerCase()}</h3>
            ${Feedback(this.me, this.other, this.profileUrl, this.feedbackGiven)}
          </div>
        </trust-modal>
        <div class='mt-8 flex justify-end items-center gap-16'>
          <trust-button dataTest="delete feedback" @click='${() => this.areYouSureYouWantToDeleteFeedback = true}' destructive small quiet>${t('Delete')} ${t('Feedback').toLowerCase()}
          </trust-button>
        </div>
      `;
        }
        const complaint = !!this.other.dispute;
        const complaintOrReport = complaint ? html `
      <span class='detail'>
        ${t('Complaint sendt')}
      </span>
    ` : html `
      <trust-button dataTest='report' small quiet destructive @click='${() => {
            this.report.setContext({ ...this.report, show: true });
            trackEvent({
                name: `Start report`,
                intent: 'Open',
                type: 'Click',
                position: this.position,
            }, 'Start report', 'button', this.vertical);
        }}'>${t('Report')}</trust-button>
    `;
        const reply = this.feedbackGiven ? this.me.reply : this.other.reply;
        const answerButtonOrNothing = reply ? DeleteReply({
            showModal: this.areYouSureYouWantToDeleteReply,
            setShowModal: (value) => {
                this.areYouSureYouWantToDeleteReply = value;
            },
            feedbackGiven: this.feedbackGiven,
            isSeller: participant.role === "SELLER",
            reply,
            showDeleteButton: reply && this.me.isCurrentUser,
            token: this.token
        })
            :
                html `
        <trust-button dataTest='reply' secondary small @click='${() => this.reply.setContext({ show: true })}'>${t('Reply')}</trust-button>
      `;
        // Todo: Remove experiment code when experiment is over
        const buttonGroup = html `
      <trust-experiment experiment="trust.my.feedback.report" group="control">
        ${!this.reply.show && !this.report.show ? html `
        <div class='mt-8 flex justify-end items-center gap-16'>
          ${complaintOrReport}
          ${answerButtonOrNothing}
        </div>` : nothing}
      </trust-experiment>
      <trust-experiment experiment="trust.my.feedback.report" group="challenger">
      ${!this.reply.show ? html `
        <div class='mt-8 flex justify-end items-center gap-16' >
          ${complaintOrReport}
          ${answerButtonOrNothing}
        </div>
      ` : nothing}
      </trust-experiment>
    `;
        const replyOrNothing = this.reply.show ? GiveReply({
            input: this.reply.input,
            tradeId: this.reply.tradeId,
            setInput: (newInput) => { this.reply.setContext({ input: newInput }); },
            tradeToken: (_a = this.reply) === null || _a === void 0 ? void 0 : _a.tradeToken,
            closeReply: (() => {
                this.reply.reset();
            }),
        }) : nothing;
        return html `
      ${buttonGroup}
      ${replyOrNothing}
      <trust-report-button token=${this.token}></trust-report-button>
    `;
    }
    async deleteFeedback() {
        await deleteApiAbsoluteURL(this.deleteUrl, this.token);
        this.dispatchEvent(updateEvent);
    }
};
__decorate([
    consume({ context: reportContext, subscribe: true })
], PrivateListingButtonGroup.prototype, "report", void 0);
__decorate([
    consume({ context: replyContext, subscribe: true })
], PrivateListingButtonGroup.prototype, "reply", void 0);
__decorate([
    property()
], PrivateListingButtonGroup.prototype, "me", void 0);
__decorate([
    property()
], PrivateListingButtonGroup.prototype, "other", void 0);
__decorate([
    property()
], PrivateListingButtonGroup.prototype, "profileUrl", void 0);
__decorate([
    property({ type: Boolean })
], PrivateListingButtonGroup.prototype, "feedbackGiven", void 0);
__decorate([
    property({ type: String })
], PrivateListingButtonGroup.prototype, "deleteUrl", void 0);
__decorate([
    property()
], PrivateListingButtonGroup.prototype, "token", void 0);
__decorate([
    state()
], PrivateListingButtonGroup.prototype, "areYouSureYouWantToDeleteFeedback", void 0);
__decorate([
    state()
], PrivateListingButtonGroup.prototype, "areYouSureYouWantToDeleteReply", void 0);
PrivateListingButtonGroup = __decorate([
    customElement('trust-private-listing-button-group')
], PrivateListingButtonGroup);
export { PrivateListingButtonGroup };
//# sourceMappingURL=PrivateListingButtonGroup.js.map